import {
    configureStore,
    Store
} from '@reduxjs/toolkit';


import {ProductsReducer} from '../features/products/reducers';
import {OffersReducer} from '../features/offers/reducers';
import {RegistrationsReducer} from '../features/registrations/reducers';
import {MeteringRecordsReducer} from '../features/metering-records/reducers';
import {NotificationSubscriptionsReducer} from '../features/notification-subscriptions/reducers';

// Row selection state (FNP-951). Records are React Query's job; selection is Redux's.
const reducers = {
    products: ProductsReducer,
    offers: OffersReducer,
    registrations: RegistrationsReducer,
    'metering-records': MeteringRecordsReducer,
    'notification-subscriptions': NotificationSubscriptionsReducer,
};

// FNP-958: a factory so tests can build an isolated store, optionally seeded.
// The test harness previously accepted a `preloadedState` argument and then
// rendered against the shared `store` singleton below, so seeding was silently
// ignored AND state leaked between test cases.
export const setupStore = (preloadedState?: Record<string, unknown>): Store =>
    configureStore({
        reducer: reducers,
        preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
            }),
    });

export const store: Store = setupStore();


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
